import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility';

const initialState = {
  count: null,
  folders: null,
  pageS: 9,
  loading: null,
  error: null,
  selectedClientFolderId: null,
};

const selectFolderId = (state, action) => {
  return updateObject(state, {
    selectedClientFolderId: action.folderId,
  });
};

const fetchFolderStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchFolderSuccess = (state, action) => {
  return updateObject(state, {
    count: action.count,
    folders: action.folders,
    error: null,
    loading: false,
  });
};

const fetchFolderFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const createFolderStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const createFolderSuccess = (state, action) => {
  let newArr = null;
  if (state.pageS === state.folders.length) {
    let oldArr = [...state.folders];
    oldArr.pop();
    oldArr.unshift(action.newfolder);
    newArr = [...oldArr];
  } else {
    let oldArr = [...state.folders];
    oldArr.unshift(action.newfolder);
    newArr = [...oldArr];
  }

  return updateObject(state, {
    count: state.count + 1,
    folders: newArr,
    error: null,
    loading: false,
  });
};

const createFolderFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// for delete
const deleteFolderStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const deleteFolderSuccess = (state, action) => {
  const updatedArray = state.folders.filter(
    (folder) => folder._id !== action.folderId
  );
  // console.log(updatedArray);
  return updateObject(state, {
    folders: updatedArray,
    error: null,
    loading: false,
  });
};

const deleteFolderFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// for Rename folder
const renameFolderStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const renameFolderSuccess = (state, action) => {
  // console.log(action.name);
  const updatedArray = state.folders.map((folder) => {
    if (folder._id === action.folderId) {
      folder.name = action.name;
    }
    return folder;
  });
  // console.log(updatedArray);
  return updateObject(state, {
    folders: updatedArray,
    error: null,
    loading: false,
  });
};

const renameFolderFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const clearMsgFolder = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    msg: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_FOLDERS_START:
      return fetchFolderStart(state, action);
    case actionTypes.FETCH_USER_FOLDERS_SUCCESS:
      return fetchFolderSuccess(state, action);
    case actionTypes.FETCH_USER_FOLDERS_FAIL:
      return fetchFolderFail(state, action);

    case actionTypes.CREATE_FOLDER_CLIENT_START:
      return createFolderStart(state, action);
    case actionTypes.CREATE_FOLDER_CLIENT_SUCCESS:
      return createFolderSuccess(state, action);
    case actionTypes.CREATE_FOLDER_CLIENT_FAIL:
      return createFolderFail(state, action);

    case actionTypes.DELETE_CLIENT_FOLDERS_START:
      return deleteFolderStart(state, action);
    case actionTypes.DELETE_CLIENT_FOLDERS_SUCCESS:
      return deleteFolderSuccess(state, action);
    case actionTypes.DELETE_CLIENT_FOLDERS_FAIL:
      return deleteFolderFail(state, action);

    case actionTypes.RENAME_CLIENT_FOLDERS_START:
      return renameFolderStart(state, action);
    case actionTypes.RENAME_CLIENT_FOLDERS_SUCCESS:
      return renameFolderSuccess(state, action);
    case actionTypes.RENAME_CLIENT_FOLDERS_FAIL:
      return renameFolderFail(state, action);

    case actionTypes.CLEAR_MSG_CLIENT_FOLDER:
      return clearMsgFolder(state, action);

    case actionTypes.SELECT_CLIENT_FOLDER:
      return selectFolderId(state, action);
    default:
      return state;
  }
};

export default reducer;
